<script>
import IconProfile from '@/components/icon/IconProfile.vue';
import constants from '@/constants';

export default {
    name: 'ButtonPartners',

    components: {
        ButtonIcon: IconProfile,
    },

    computed: {
        constants() {
            return constants;
        },
        canAccess() {
            return !!(
                this.$store.getters.USER_PERMISSIONS &&
                this.$store.getters.USER_PERMISSIONS.can_use_admin
            );
        },
    },
};
</script>

<template>
    <router-link
        v-if="canAccess"
        class="left_button_main_container"
        :to="{ name: constants.ROUTER_NAME.PARTNERS }"
    >
        <div class="left_button_icon_container">
            <ButtonIcon iconWidth="16px" iconHeight="16px" />
        </div>
        <div class="left_button_label_container">
            <label class="cursor_pointer">Partners</label>
        </div>
    </router-link>
</template>
